const paymentTypes = {
  TIER: 'TIER',
  HOURLY: 'HOURLY',
  MONTHLY: 'MONTHLY',
};

const paymentTypeLimits = {
  FLOOR: 'FLOOR',
  BETWEEN: 'BETWEEN',
  CEILING: 'CEILING',
};

const FLOOR_LIMIT = 20;
const CEILING_LIMIT = 29;

const paymentTypeOptions = [
  { value: paymentTypes.TIER, label: 'Tier' },
  { value: paymentTypes.HOURLY, label: 'Hourly' },
  { value: paymentTypes.MONTHLY, label: 'Monthly' },
];

export { paymentTypes, paymentTypeOptions, paymentTypeLimits, FLOOR_LIMIT, CEILING_LIMIT };
